// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2lTMm","kalera":"style_kalera__1gpQL","version":"style_version__13KF5"};